import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
	NgbPagination,
	NgbPaginationEllipsis,
	NgbPaginationFirst,
	NgbPaginationLast,
	NgbPaginationNext,
	NgbPaginationNumber,
	NgbPaginationPrevious,
	NgbPaginationPages,
} from './pagination';

export {
	NgbPagination,
	NgbPaginationEllipsis,
	NgbPaginationFirst,
	NgbPaginationLast,
	NgbPaginationNext,
	NgbPaginationNumber,
	NgbPaginationPrevious,
	NgbPaginationPages,
} from './pagination';
export { NgbPaginationConfig } from './pagination-config';

const DIRECTIVES = [
	NgbPagination,
	NgbPaginationEllipsis,
	NgbPaginationFirst,
	NgbPaginationLast,
	NgbPaginationNext,
	NgbPaginationNumber,
	NgbPaginationPrevious,
	NgbPaginationPages,
];

@NgModule({ declarations: DIRECTIVES, exports: DIRECTIVES, imports: [CommonModule] })
export class NgbPaginationModule {}
